(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sagrada-category-slider')) {
  customElements.define('sagrada-category-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.viewport = this.querySelector('[data-category-viewport]');
      this.prev = this.querySelector('[data-category-prev]');
      this.next = this.querySelector('[data-category-next]');
      this.controls = this.querySelector('.se-category-controls');
      this.stage = this.querySelector('.se-category-stage');
      this.firstMedia = this.querySelector('.se-category-media');
      this.events = new AbortController();
      const options = { signal:this.events.signal };
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.viewport.addEventListener('scroll', () => this.update(), { ...options, passive:true });
      this.viewport.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('[data-category-item]');
        if (item) this.viewport.scrollTo({left:item.offsetLeft - this.viewport.offsetLeft, behavior:'auto'});
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.viewport);
      if (this.firstMedia) this.observer.observe(this.firstMedia);
      this.update();
    }
    disconnectedCallback() { this.events?.abort(); this.events=null; this.observer?.disconnect(); }
    move(direction) {
      const max = Math.max(0,this.viewport.scrollWidth - this.viewport.clientWidth);
      const target = Math.max(0,Math.min(max,this.viewport.scrollLeft + direction * this.viewport.clientWidth));
      this.viewport.scrollTo({left:target, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    update() {
      const max = Math.max(0,this.viewport.scrollWidth - this.viewport.clientWidth);
      this.controls.hidden = max <= 2;
      if (max > 2 && this.firstMedia && this.stage) {
        const image = this.firstMedia.getBoundingClientRect();
        const stage = this.stage.getBoundingClientRect();
        this.stage.style.setProperty('--category-arrow-y', (image.top - stage.top + image.height / 2) + 'px');
      }
      this.prev.disabled = this.viewport.scrollLeft <= 2;
      this.next.disabled = this.viewport.scrollLeft >= max - 2;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compre-junto-sagrada"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sagrada-buy-together')) {
  customElements.define('sagrada-buy-together', class extends HTMLElement {
    connectedCallback() {
      if(this.events)return;
      this.events=new AbortController();this.busy=false;
      this.texts=JSON.parse(this.querySelector('[data-together-texts]').textContent);
      this.form=this.querySelector('form');this.button=this.querySelector('[data-together-submit]');
      this.feedback=this.querySelector('[data-together-feedback]');this.label=this.button.textContent;
      this.currency=new Intl.NumberFormat(this.dataset.locale||'pt-BR',{style:'currency',currency:this.dataset.currency||'BRL'});
      this.addEventListener('change',()=>this.update(),{signal:this.events.signal});
      this.form.addEventListener('submit',event=>{event.preventDefault();this.add();},{signal:this.events.signal});
      this.categorySelect=this.querySelector('[data-together-category]');
      if(this.categorySelect){
        this.categorySelect.addEventListener('change',()=>this.changeCategory(),{signal:this.events.signal});

      }
      this.initSearch();
      this.update();
    }
    disconnectedCallback(){this.categoryController?.abort();this.categoryRequest++;clearTimeout(this.searchTimer);this.searchController?.abort();this.searchVersion++;this.events?.abort();this.events=null;}
    initSearch(){
      this.searchInput=this.querySelector('[data-together-search]');
      if(!this.searchInput)return;
      this.searchResults=this.querySelector('[data-together-search-results]');
      this.searchStatus=this.querySelector('[data-together-search-status]');this.searchVersion=0;
      this.searchInput.addEventListener('input',()=>{
        clearTimeout(this.searchTimer);this.searchController?.abort();const version=++this.searchVersion;
        const term=this.searchInput.value.trim();this.searchResults.replaceChildren();this.searchStatus.textContent='';
        if(term)this.searchTimer=setTimeout(()=>this.searchProducts(term,version),250);
      },{signal:this.events.signal});
      this.searchInput.addEventListener('keydown',event=>{if(event.key==='Enter')event.preventDefault();if(event.key==='Escape'){this.searchResults.replaceChildren();this.searchStatus.textContent='';++this.searchVersion;this.searchController?.abort();}},{signal:this.events.signal});
    }
    safeURL(value){
      if(typeof value!=='string'||!value)return null;
      try{const url=new URL(value,location.origin);return url.protocol==='https:'||url.protocol==='http:'?url:null;}catch{return null;}
    }
    async searchProducts(term,version){
      this.searchController=new AbortController();this.searchStatus.textContent=this.texts.search_loading;
      try{
        const root=window.Shopify?.routes?.root||'/';
        const url=new URL(root+'search/suggest.json',location.origin);
        url.searchParams.set('q',term);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','6');url.searchParams.set('resources[options][unavailable_products]','hide');
        const response=await fetch(url,{signal:this.searchController.signal,headers:{Accept:'application/json'}});
        if(!response.ok)throw Error();const data=await response.json();
        if(version!==this.searchVersion||!this.isConnected)return;
        const products=data?.resources?.results?.products;if(!Array.isArray(products))throw Error();
        this.searchResults.replaceChildren();
        for(const product of products){
          const url=this.safeURL(product.url);if(!url||url.origin!==location.origin)continue;
          const li=document.createElement('li'),button=document.createElement('button');button.type='button';button.className='se-together__search-result';
          const imageURL=this.safeURL(product.featured_image?.url||product.image);
          if(imageURL){const image=document.createElement('img');image.src=imageURL.href;image.alt='';image.width=48;image.height=48;image.loading='lazy';button.append(image);}
          const title=document.createElement('span');title.textContent=product.title;button.append(title);
          const action=document.createElement('span');action.textContent=this.texts.search_action;button.append(action);
          button.addEventListener('click',()=>this.includeSearchedProduct(url,button),{signal:this.events.signal});
          li.append(button);this.searchResults.append(li);
        }
        this.searchStatus.textContent=this.searchResults.children.length?this.texts.search_choose:this.texts.search_empty;
      }catch(error){if(version===this.searchVersion&&error.name!=='AbortError')this.searchStatus.textContent=this.texts.search_error;}
    }
    async includeSearchedProduct(url,button){
      if(this.busy||this.searchLoading||this.categoryLoading)return;
      this.searchLoading=true;button.disabled=true;
      try{
        const endpoint=new URL(url.href);endpoint.search='';endpoint.hash='';endpoint.pathname=endpoint.pathname.replace(/\/$/,'')+'.js';
        const response=await fetch(endpoint,{headers:{Accept:'application/json'}});
        if(!response.ok)throw Error(this.texts.load_product_error);
        const product=await response.json();
        if(!this.isConnected)return;
        if(this.busy)throw Error(this.texts.busy_message);
        if(product.requires_selling_plan)throw Error(this.texts.subscription_message);
        if(!Array.isArray(product.variants)||!product.variants.some(v=>v.available))throw Error(this.texts.unavailable_message);
        const grid=this.querySelector('.se-together__grid');
        const existing=Array.from(grid.querySelectorAll('[data-together-card]')).find(card=>card.dataset.productId===String(product.id));
        if(existing){existing.querySelector('[data-together-check]').checked=true;this.update();this.searchStatus.textContent=this.texts.search_existing;return;}
        const card=document.createElement('article');card.className='se-together__card';card.dataset.togetherCard='';card.dataset.productId=String(product.id);
        // HTML fixo; dados externos são inseridos apenas com textContent e propriedades.
        card.innerHTML='<label class="se-together__check"><input type="checkbox" data-together-check checked><span></span></label><a class="se-together__photo"></a><h3><a></a></h3><label class="se-together__variant-label"></label><select data-together-variant></select><strong class="se-together__price" data-together-price></strong>';
        card.querySelector('.se-together__check span').textContent=this.texts.selected_label+' '+product.title;
        const photo=card.querySelector('.se-together__photo');photo.href=url.href;
        const imageURL=this.safeURL(product.featured_image);
        if(imageURL){const image=document.createElement('img');image.src=imageURL.href;image.alt=product.title;image.loading='lazy';photo.append(image);}
        const link=card.querySelector('h3 a');link.href=url.href;link.textContent=product.title;
        const select=card.querySelector('select');select.id='TogetherSearchVariant-'+this.closest('section').id+'-'+product.id;
        const label=card.querySelector('.se-together__variant-label');label.htmlFor=select.id;label.textContent=this.texts.variant_label;
        let selected=false;
        for(const variant of product.variants){
          const option=document.createElement('option');option.value=String(variant.id);option.dataset.price=String(variant.price);option.disabled=!variant.available;
          option.textContent=(variant.title==='Default Title'?this.texts.single_variant_label:variant.title)+' — '+this.currency.format(variant.price/100)+(variant.available?'':' · '+this.texts.sold_out_label);
          if(!selected&&variant.available){option.selected=true;selected=true;}select.append(option);
        }
        grid.append(card);this.update();this.searchStatus.textContent=this.texts.search_included;
      }catch(error){this.searchStatus.textContent=error.message||this.texts.include_error;}
      finally{this.searchLoading=false;button.disabled=false;}
    }

    async changeCategory(){
      if(this.busy)return;
      const handle=this.categorySelect.value;
      const request=this.categoryRequest=(this.categoryRequest||0)+1;
      this.categoryController?.abort();
      this.categoryLoading=true;this.update();
      this.categoryCache=this.categoryCache||new Map();
      let template=Array.from(this.querySelectorAll('template[data-category-template]')).find(item=>item.dataset.categoryTemplate===handle)||this.categoryCache.get(handle);
      try {
        if(!template){
          this.categoryController=new AbortController();
          const root=window.Shopify?.routes?.root||'/';
          const url=new URL(root+'collections/'+encodeURIComponent(handle),location.origin);
          url.searchParams.set('section_id','sagrada-together-category');
          const response=await fetch(url,{signal:this.categoryController.signal,headers:{Accept:'text/html'}});
          if(!response.ok)throw new Error();
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const content=doc.querySelector('[data-category-response]');if(!content)throw new Error();
          template=document.createElement('template');
          content.querySelectorAll('[data-together-card]').forEach(card=>template.content.append(card));
          this.categoryCache.set(handle,template);
        }
      }catch(error){
        if(request===this.categoryRequest){
          this.categoryLoading=false;this.update();
          if(error.name!=='AbortError')this.querySelector('[data-category-feedback]').textContent=this.texts.search_error;
        }
        return;
      }
      if(request!==this.categoryRequest||!this.isConnected)return;
      this.categoryLoading=false;
      if(this.busy){this.update();return;}
      const grid=this.querySelector('.se-together__grid');
      // Mantém as escolhas já feitas, incluindo a variante do produto principal.
      const kept=Array.from(grid.querySelectorAll('[data-together-card]')).filter(card=>card.hasAttribute('data-current-product')||card.querySelector('[data-together-check]').checked);
      const ids=new Set(kept.map(card=>card.dataset.productId));
      const content=template.content.cloneNode(true);
      const suggestions=Array.from(content.querySelectorAll('[data-together-card]')).filter(card=>!ids.has(card.dataset.productId)&&card.dataset.productId!==this.dataset.currentProductId).slice(0,Number(this.dataset.relatedLimit)||3);
      suggestions.forEach(card=>{
        card.querySelector('.se-together__check span').textContent=this.texts.select_label;
        card.querySelector('.se-together__variant-label').textContent=this.texts.variant_label;
        const select=card.querySelector('select');
        const old=select.id;select.id=this.closest('section').id+'-'+old;
        card.querySelector('.se-together__variant-label').htmlFor=select.id;
      });
      grid.replaceChildren(...kept,...suggestions);
      this.querySelector('[data-category-feedback]').textContent=suggestions.length?'':this.dataset.categoryEmpty;
      this.update();
    }
    selection(){
      return Array.from(this.querySelectorAll('[data-together-card]')).filter(card=>card.querySelector('[data-together-check]').checked).map(card=>{
        const option=card.querySelector('select').selectedOptions[0];
        return option&&!option.disabled?{id:Number(option.value),quantity:1,price:Number(option.dataset.price)}:null;
      }).filter(Boolean);
    }
    update(){
      this.querySelectorAll('[data-together-card]').forEach(card=>{const option=card.querySelector('select').selectedOptions[0];if(option)card.querySelector('[data-together-price]').textContent=this.currency.format(Number(option.dataset.price)/100);});
      const items=this.selection();
      this.querySelector('[data-together-total]').textContent=this.currency.format(items.reduce((sum,item)=>sum+item.price,0)/100);
      this.querySelector('[data-together-count]').textContent=items.length+' '+(items.length===1?this.texts.count_single:this.texts.count_plural);
      this.button.disabled=this.busy||this.categoryLoading||!items.length;
    }
    async add(){
      if(this.busy||this.searchLoading)return;
      const selected=this.selection();if(!selected.length)return;
      this.busy=true;this.update();this.feedback.textContent='';this.button.textContent=this.dataset.loading;
      this.querySelectorAll('select,input').forEach(field=>field.disabled=true);
      let added=false;
      try{
        const drawer=document.querySelector('cart-drawer');
        const canRender=drawer&&typeof drawer.getSectionsToRender==='function'&&typeof drawer.renderContents==='function';
        const body={items:selected.map(({id,quantity})=>({id,quantity}))};
        if(canRender){body.sections=drawer.getSectionsToRender().map(section=>section.id).slice(0,5);body.sections_url=location.pathname;drawer.setActiveElement?.(this.button);}
        const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
        const result=await response.json();
        if(!response.ok||result.status)throw new Error(result.description||result.message||this.dataset.error);
        added=true;this.feedback.textContent=this.dataset.success;
        const sectionsOK=canRender&&body.sections.every(id=>typeof result.sections?.[id]==='string');
        if(sectionsOK){drawer.classList.remove('is-empty');drawer.renderContents(result);}
        else location.assign(this.dataset.cartUrl);
      }catch(error){
        this.feedback.textContent=added?this.dataset.success+' '+this.texts.check_cart_message:(error instanceof TypeError?this.dataset.error:error.message||this.dataset.error);
      }finally{
        this.busy=false;this.button.textContent=this.label;
        this.querySelectorAll('select,input').forEach(field=>field.disabled=false);this.update();
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ervya-barra-seguranca"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sagrada-trust-slider')) {
  customElements.define('sagrada-trust-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.viewport = this.querySelector('[data-trust-viewport]');
      this.prev = this.querySelector('[data-trust-prev]');
      this.next = this.querySelector('[data-trust-next]');
      this.controls = this.querySelector('.ervya-trust__controls');
      this.events = new AbortController();
      const options = { signal:this.events.signal };
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.viewport.addEventListener('scroll', () => this.update(), { ...options, passive:true });
      this.viewport.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('[data-trust-item]');
        if (item) this.viewport.scrollTo({left:item.offsetLeft - this.viewport.offsetLeft, behavior:'auto'});
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.viewport);
      this.update();
    }
    disconnectedCallback() { this.events?.abort(); this.events=null; this.observer?.disconnect(); }
    move(direction) {
      const max = Math.max(0,this.viewport.scrollWidth - this.viewport.clientWidth);
      const target = Math.max(0,Math.min(max,this.viewport.scrollLeft + direction * this.viewport.clientWidth));
      this.viewport.scrollTo({left:target, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    update() {
      const max = Math.max(0,this.viewport.scrollWidth - this.viewport.clientWidth);
      this.controls.hidden = max <= 2;
      this.prev.disabled = this.viewport.scrollLeft <= 2;
      this.next.disabled = this.viewport.scrollLeft >= max - 2;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search, sagrada-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.contains(document.activeElement) || [...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  if (!customElements.get('sagrada-search')) {
    customElements.define('sagrada-search', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.input = this.querySelector('input[name="q"]');
        this.form = this.querySelector('form');
        this.panel = this.querySelector('.se-search-panel');
        this.list = this.querySelector('[role="listbox"]');
        this.message = this.querySelector('[data-search-message]');
        this.status = this.querySelector('[data-search-status]');
        this.all = this.querySelector('.se-search-all');
        this.clear = this.querySelector('.se-search-clear');
        this.cache = new Map(); this.version = 0; this.active = -1; this.isOpen = false;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.input.addEventListener('input', () => { if (!this.composing) this.schedule(); }, options);
        this.input.addEventListener('compositionstart', () => { this.composing = true; this.cancel(); }, options);
        this.input.addEventListener('compositionend', () => { this.composing = false; this.schedule(); }, options);
        this.input.addEventListener('focus', () => { if (this.input.value.trim()) this.schedule(); }, options);
        this.input.addEventListener('keydown', (event) => this.onKey(event), options);
        this.clear.addEventListener('click', () => { this.input.value = ''; this.cancel(); this.close(); this.clear.hidden = true; this.input.focus(); }, options);
        this.form.addEventListener('submit', (event) => {
          if (!this.input.value.trim()) { event.preventDefault(); this.input.focus(); }
          this.cancel(); this.close();
        }, options);
        document.addEventListener('pointerdown', (event) => { if (!this.contains(event.target)) { this.cancel(); this.close(); } }, options);
        this.addEventListener('focusout', () => {
          clearTimeout(this.blurTimer);
          this.blurTimer = setTimeout(() => { if (!this.contains(document.activeElement)) { this.cancel(); this.close(); } }, 0);
        }, options);
        this.clear.hidden = !this.input.value;
      }
      disconnectedCallback() {
        this.cancel(); clearTimeout(this.blurTimer); this.events?.abort(); this.events = null;
      }
      cancel() {
        clearTimeout(this.timer); this.controller?.abort(); this.version = (this.version || 0) + 1;
        this.list?.removeAttribute('aria-busy');
      }
      close() {
        this.panel.hidden = true; this.isOpen = false; this.input.setAttribute('aria-expanded', 'false');
        this.setActive(-1); this.status.textContent = '';
      }
      open() {
        this.panel.hidden = false; this.isOpen = true; this.input.setAttribute('aria-expanded', 'true');
      }
      searchURL(term) {
        const url = new URL(this.form.action, location.origin);
        url.searchParams.set('q', term); url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        url.searchParams.set('options[unavailable_products]', 'last');
        return url.href;
      }
      schedule() {
        this.cancel(); this.close();
        const term = this.input.value.trim(); this.clear.hidden = !this.input.value;
        if (!term) return;
        const version = this.version;
        // Aguarda uma pausa curta de digitação e descarta respostas antigas.
        this.timer = setTimeout(() => this.load(term, version), 220);
      }
      async load(term, version) {
        if (version !== this.version) return;
        this.all.href = this.searchURL(term); this.all.textContent = 'Ver todos os resultados →';
        this.list.replaceChildren(); this.setActive(-1);
        this.message.hidden = false; this.message.textContent = 'Buscando produtos…';
        this.status.textContent = 'Buscando produtos'; this.list.setAttribute('aria-busy', 'true'); this.open();
        const controller = new AbortController(); this.controller = controller;
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          let products = this.cache.get(term);
          if (!products) {
            const base = this.dataset.endpoint || ((window.Shopify?.routes?.root || '/') + 'search/suggest');
            const url = new URL(base.replace(/\.json$/, '') + '.json', location.origin);
            url.searchParams.set('q', term); url.searchParams.set('resources[type]', 'product');
            url.searchParams.set('resources[limit]', '6');
            url.searchParams.set('resources[options][unavailable_products]', 'last');
            const response = await fetch(url.href, { signal: controller.signal, headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error('Busca indisponível');
            const data = await response.json(); products = data?.resources?.results?.products;
            if (!Array.isArray(products)) throw new Error('Resposta inválida');
            if (version !== this.version) return;
            if (this.cache.size >= 30) this.cache.delete(this.cache.keys().next().value);
            this.cache.set(term, products);
          }
          if (version !== this.version || !this.isConnected) return;
          this.render(products, term);
        } catch (error) {
          if (version !== this.version || !this.isConnected) return;
          this.list.replaceChildren(); this.message.hidden = false;
          this.message.textContent = 'As sugestões não estão disponíveis agora. Pressione Enter ou veja todos os resultados.';
          this.status.textContent = this.message.textContent;
        } finally {
          clearTimeout(timeout);
          if (version === this.version) this.list.removeAttribute('aria-busy');
        }
      }
      render(products, term) {
        this.list.replaceChildren(); this.setActive(-1);
        let count = 0;
        for (const product of products.slice(0, 6)) {
          const href = this.safeURL(product.url, true); if (!href) continue;
          const item = document.createElement('li'); item.className = 'se-search-option';
          item.id = this.list.id + '-item-' + count; item.setAttribute('role', 'option'); item.setAttribute('aria-selected', 'false');
          const link = document.createElement('a'); link.href = href; link.tabIndex = -1;
          const imageURL = this.safeURL(product.featured_image?.url || product.image);
          if (imageURL) {
            const image = document.createElement('img'); image.className = 'se-search-thumb';
            image.src = imageURL; image.alt = ''; image.width = 58; image.height = 64; image.loading = 'lazy'; link.append(image);
          }
          const copy = document.createElement('span'); copy.className = 'se-search-copy';
          const title = document.createElement('span'); title.className = 'se-search-title';
          title.textContent = String(product.title || 'Ver produto'); copy.append(title);
          const value = this.price(product.price);
          if (value) { const price = document.createElement('span'); price.className = 'se-search-price'; price.textContent = value; copy.append(price); }
          if (product.available === false) { const stock = document.createElement('span'); stock.className = 'se-search-stock'; stock.textContent = 'Esgotado'; copy.append(stock); }
          link.append(copy); item.append(link); this.list.append(item); count++;
        }
        this.message.hidden = count > 0;
        this.message.textContent = count ? '' : 'Nenhum produto encontrado. Tente outro nome ou ingrediente.';
        this.status.textContent = count ? `${count} produtos sugeridos para ${term}. Use as setas para navegar.` : this.message.textContent;
        this.all.href = this.searchURL(term); this.open();
      }
      safeURL(value, sameOrigin = false) {
        if (typeof value !== 'string' || !value) return '';
        try {
          const url = new URL(value, location.origin);
          if (!['https:', 'http:'].includes(url.protocol) || (sameOrigin && url.origin !== location.origin)) return '';
          return url.href;
        } catch { return ''; }
      }
      price(value) {
        // suggest.json retorna preços decimais em unidades monetárias, não centavos.
        if (value === null || value === undefined || value === '') return '';
        const amount = Number(value); if (!Number.isFinite(amount)) return '';
        try { return new Intl.NumberFormat(this.dataset.locale || 'pt-BR', { style: 'currency', currency: this.dataset.currency || 'BRL' }).format(amount); }
        catch { return ''; }
      }
      setActive(index) {
        const options = Array.from(this.list.querySelectorAll('[role="option"]'));
        this.active = index;
        options.forEach((option, i) => option.setAttribute('aria-selected', String(i === index)));
        if (options[index]) { this.input.setAttribute('aria-activedescendant', options[index].id); options[index].scrollIntoView({ block: 'nearest' }); }
        else this.input.removeAttribute('aria-activedescendant');
      }
      onKey(event) {
        if (event.isComposing) return;
        if (event.key === 'Escape') { this.cancel(); this.close(); return; }
        const options = Array.from(this.list.querySelectorAll('[role="option"]'));
        if (!this.isOpen || !options.length) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          let index = this.active;
          if (event.key === 'ArrowDown') index = index < 0 ? 0 : (index + 1) % options.length;
          else index = index < 0 ? options.length - 1 : (index - 1 + options.length) % options.length;
          this.setActive(index);
        } else if (event.key === 'Enter' && this.active >= 0) {
          event.preventDefault(); options[this.active].querySelector('a').click();
        }
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sagrada-monte-kit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sagrada-kit-builder')) {
  customElements.define('sagrada-kit-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.cfg = JSON.parse(this.querySelector('[data-kit-config]').textContent);
      this.root = window.Shopify?.routes?.root || this.dataset.root || '/';
      if (!this.root.endsWith('/')) this.root += '/';
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style:'currency', currency:this.dataset.currency || 'BRL' });
      this.items = new Map(); this.products = new Map(); this.version = 0; this.busy = false; this.locked = false;
      this.grid = this.querySelector('[data-kit-grid]'); this.search = this.querySelector('[data-kit-search]');
      this.category = this.querySelector('[data-kit-category]'); this.status = this.querySelector('[data-kit-status]');
      this.feedback = this.querySelector('[data-kit-feedback]'); this.button = this.querySelector('[data-kit-checkout]');
      this.more = this.querySelector('[data-kit-more]'); this.summary = this.querySelector('[data-kit-summary]');
      this.kitId = window.crypto?.randomUUID?.() || 'kit-' + Date.now() + '-' + Math.random().toString(36).slice(2);
      const options = { signal:this.events.signal };
      this.search.addEventListener('input', event => {
        clearTimeout(this.debounce);this.controller?.abort();++this.version;
        this.nextUrl='';this.more.hidden=true;this.more.disabled=true;
        this.category.value=this.dataset.allUrl;
        this.filterVisibleProducts();
        if(event.isComposing)return;
        this.debounce=setTimeout(()=>this.load(false),180);
      },options);
      this.search.addEventListener('compositionend',()=>{clearTimeout(this.debounce);this.debounce=setTimeout(()=>this.load(false),180);},options);
      this.search.addEventListener('keydown', event => { if (event.key === 'Enter'&&!event.isComposing) { event.preventDefault(); clearTimeout(this.debounce); this.load(false); } }, options);
      this.category.addEventListener('change', () => { this.search.value = ''; clearTimeout(this.debounce); this.load(false); }, options);
      this.querySelector('[data-kit-continue]')?.addEventListener('click',()=>this.querySelector('.sk-toolbar').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'}),options);
      this.more.addEventListener('click', () => this.load(true), options);
      this.button.addEventListener('click', () => this.checkout(), options);
      this.querySelector('[data-kit-view]').addEventListener('click', () => this.openSummary(), options);
      this.addEventListener('click', event => {
        const step=event.target.closest('[data-kit-step]');
        if(step&&!this.busy&&!this.locked){
          const card=step.closest('[data-kit-product]');
          const key=step.dataset.kitKey||card?.querySelector('[data-kit-variant]')?.value;
          if(step.dataset.kitStep==='1'&&card)this.addCard(card);
          else {const item=this.items.get(key);if(item){item.quantity=this.quantity(item.quantity+Number(step.dataset.kitStep));this.renderSummary();}}
        }
        const add = event.target.closest('[data-kit-add]');
        if (add) this.addCard(add.closest('[data-kit-product]'));
        const remove = event.target.closest('[data-kit-remove]');
        if (remove && !this.busy && !this.locked) { this.items.delete(remove.dataset.kitRemove); this.renderSummary(); }
      }, options);
      this.addEventListener('input',event=>{
        if(!event.target.matches('[data-kit-item-qty]')||this.busy||this.locked||event.target.value==='')return;
        const key=event.target.dataset.kitItemQty,item=this.items.get(key);if(!item)return;
        item.quantity=this.quantity(event.target.value);this.renderSummary();
        const replacement=Array.from(this.querySelectorAll('[data-kit-item-qty]')).find(input=>input.dataset.kitItemQty===key);
        replacement?.focus({preventScroll:true});
      },options);
      this.addEventListener('change', event => {
        const card = event.target.closest('[data-kit-product]');
        if (card && event.target.matches('[data-kit-variant]')) this.updateCard(card);
        if (event.target.matches('[data-kit-item-qty]') && !this.busy && !this.locked) {
          const item = this.items.get(event.target.dataset.kitItemQty);
          if (item) { item.quantity = this.quantity(event.target.value); this.renderSummary(); }
        }
      }, options);
      this.sticky=this.querySelector('[data-kit-sticky]');
      if(this.sticky){
        this.querySelector('[data-kit-sticky-checkout]').addEventListener('click',()=>this.checkout(),options);
        this.querySelector('[data-kit-sticky-view]').addEventListener('click',()=>this.openSummary(),options);
        const schedule=()=>{if(!this.scrollFrame)this.scrollFrame=requestAnimationFrame(()=>{this.scrollFrame=0;this.updateSticky();});};
        window.addEventListener('scroll',schedule,{...options,passive:true});window.addEventListener('resize',schedule,options);
      }
      this.renderSummary(); this.load(false);
    }
    disconnectedCallback() { cancelAnimationFrame(this.scrollFrame); this.closest('.sk-section')?.classList.remove('sk-has-sticky'); clearTimeout(this.debounce); this.controller?.abort(); ++this.version; this.events?.abort(); this.events = null; }
    url(value) { try { const u = new URL(value, location.origin); return u.origin === location.origin && /^https?:$/.test(u.protocol) ? u : null; } catch { return null; } }
    quantity(value) { return Math.max(1, Math.min(99, Math.floor(Number(value)) || 1)); }
    normalizeSearch(value) {return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase('pt-BR').trim();}
    filterVisibleProducts() {
      const words=this.normalizeSearch(this.search.value).split(/\s+/).filter(Boolean);
      let matches=0;
      for(const card of this.grid.querySelectorAll('[data-kit-product]')){
        const p=this.products.get(card.dataset.productId);
        const title=this.normalizeSearch(p?.title||'');
        const match=words.every(word=>title.includes(word));card.hidden=!match;if(match)matches++;
      }
      this.grid.setAttribute('aria-busy','true');
      this.status.textContent=words.length?(this.cfg.searching_label||'Buscando no catálogo…'):this.cfg.loading_label;
    }
    endpoint() {
      const q = this.search.value.trim();
      const u = this.url(q ? this.root+'search' : this.category.value || this.dataset.allUrl);
      if (!u) throw new Error(this.cfg.catalog_error);
      u.searchParams.set('section_id','sagrada-kit-catalog');
      const previewId = new URL(location.href).searchParams.get('preview_theme_id') || (window.Shopify?.designMode ? window.Shopify?.theme?.id : null);
      if (previewId && /^\d+$/.test(String(previewId))) u.searchParams.set('preview_theme_id',String(previewId));
      if (q) { u.searchParams.set('q',q); u.searchParams.set('type','product'); u.searchParams.set('options[prefix]','last'); }
      return u;
    }
    async load(append) {
      if (append && (!this.nextUrl || this.loading)) return;
      const version = ++this.version; this.controller?.abort(); this.controller = new AbortController();
      this.loading = true; this.more.disabled = true; this.grid.setAttribute('aria-busy','true'); this.status.textContent = this.cfg.loading_label;
      try {
        const url = append ? this.url(this.nextUrl) : this.endpoint();
        if (!url) throw new Error();
        url.searchParams.set('section_id','sagrada-kit-catalog');
        if (append) for (const [key,value] of this.endpoint().searchParams) if (!url.searchParams.has(key)) url.searchParams.set(key,value);
        const response = await fetch(url.href, { signal:this.controller.signal, credentials:'same-origin', cache:'no-store', headers:{ Accept:'text/html' } });
        if (!response.ok) throw new Error('HTTP '+response.status);
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const catalog = doc.querySelector('[data-kit-catalog]');
        if (!catalog) throw new Error('Resposta sem o catálogo auxiliar');
        if (version !== this.version || !this.isConnected) return;
        const cards = Array.from(catalog.querySelectorAll('[data-kit-product]'));
        const existing = new Set(append ? Array.from(this.grid.querySelectorAll('[data-kit-product]'), c => c.dataset.productId) : []);
        const prepared = [];
        for (const card of cards) {
          const product = JSON.parse(card.querySelector('[data-kit-product-json]').textContent);
          if (!product || !Array.isArray(product.variants) || existing.has(String(product.id))) continue;
          product.variants = product.variants.filter(v => /^\d+$/.test(String(v.id)) && Number.isInteger(v.price) && v.price >= 0);
          this.products.set(String(product.id), product); existing.add(String(product.id));
          // Only fixed storefront markup is inserted; script data blocks are inert JSON.
          prepared.push(card);
        }
        if (!append) this.grid.replaceChildren();
        this.grid.append(...prepared);
        prepared.forEach(card => this.updateCard(card));
        this.nextUrl = catalog.dataset.nextUrl || ''; this.more.hidden = !this.nextUrl;
        this.status.textContent = this.grid.children.length ? this.grid.children.length + ' ' + this.cfg.results_label : this.cfg.empty_label;
      } catch (error) {
        if (version === this.version && error.name !== 'AbortError') {
          this.status.textContent = this.cfg.catalog_error;
          if (window.Shopify?.designMode) this.status.textContent += ' Editor: '+error.message+'. Confira se sections/sagrada-kit-catalog.liquid está salvo neste mesmo tema.';
        }
      } finally {
        if (version === this.version) { this.loading = false; this.more.disabled = false; this.grid.setAttribute('aria-busy','false'); }
      }
    }
    updateCard(card) {
      const p = this.products.get(card.dataset.productId); if (!p) return;
      const select = card.querySelector('[data-kit-variant]');
      const v = p.variants.find(v => String(v.id) === select.value);
      const add = card.querySelector('[data-kit-add]');
      let selected=card.querySelector('[data-kit-card-selected]');
      if(!selected){selected=document.createElement('p');selected.className='sk-card-selected';selected.dataset.kitCardSelected='';selected.setAttribute('aria-live','polite');add.closest('.sk-card-info')?.append(selected);if(!selected.isConnected)card.append(selected);}
      const selectedQuantity=v?(this.items.get(String(v.id))?.quantity||0):0;
      let controls=card.querySelector('.sk-card-stepper');
      if(!controls){
        controls=document.createElement('div');controls.className='sk-stepper sk-card-stepper';
        const input=card.querySelector('[data-kit-qty]');
        const oldLabel=input?.closest('label');
        const minus=document.createElement('button'),plus=document.createElement('button');
        for(const [button,delta,label]of [[minus,-1,this.cfg.decrease_label||'Diminuir quantidade'],[plus,1,this.cfg.increase_label||'Aumentar quantidade']]){button.type='button';button.dataset.kitStep=String(delta);button.textContent=delta<0?'−':'+';button.setAttribute('aria-label',label+': '+p.title);}
        if(input){input.readOnly=true;input.min='0';controls.append(minus,input,plus);}else controls.append(minus,plus);
        const row=document.createElement('div');row.className='sk-price-quantity';
        const price=card.querySelector('[data-kit-price]');price.before(row);row.append(price,controls);oldLabel?.remove();
      }
      const cardQty=controls.querySelector('[data-kit-qty]');if(cardQty)cardQty.value=String(selectedQuantity);
      controls.querySelector('[data-kit-step="-1"]').disabled=this.busy||this.locked||selectedQuantity<=1;
      controls.querySelector('[data-kit-step="1"]').disabled=this.busy||this.locked||!v?.available||v.requires_selling_plan||selectedQuantity>=99;
      selected.hidden=!selectedQuantity;
      selected.textContent=(this.cfg.in_kit_label||'No seu kit: {quantidade} unidades').replace('{quantidade}',String(selectedQuantity));
      card.classList.toggle('sk-card-in-kit',selectedQuantity>0);
      card.querySelector('[data-kit-price]').textContent = v ? this.money.format(v.price/100) : '';
      add.disabled = this.busy || this.locked || !v?.available || v.requires_selling_plan;
      add.textContent = !v?.available ? this.cfg.sold_out_label : v.requires_selling_plan ? this.cfg.subscription_label : this.cfg.add_label;
    }
    addCard(card) {
      if (this.busy || this.locked || !card) return;
      const p = this.products.get(card.dataset.productId), v = p?.variants.find(v => String(v.id) === card.querySelector('select').value);
      if (!v?.available || v.requires_selling_plan) return;
      const key = String(v.id), quantity = 1;
      const old = this.items.get(key);
      this.items.set(key,{ id:v.id, title:p.title, variant:v.title, url:p.url, image:p.image, price:v.price, quantity:this.quantity((old?.quantity || 0)+quantity) });
      this.feedback.textContent = p.title + ' — ' + this.cfg.added_label; this.renderSummary();
    }
    renderSummary() {
      const list = this.querySelector('[data-kit-items]'); list.replaceChildren();
      let total = 0, units = 0;
      for (const [key,item] of this.items) {
        total += item.price * item.quantity; units += item.quantity;
        const li = document.createElement('li'); li.className = 'sk-item';
        const text = document.createElement('div'), title = document.createElement('strong'), variant = document.createElement('small');
        title.textContent = item.title; variant.textContent = item.variant === 'Default Title' ? this.cfg.single_variant_label : item.variant;
        text.append(title,variant);
        const qty = document.createElement('input'); qty.type='number'; qty.min='1'; qty.max='99'; qty.step='1'; qty.value=String(item.quantity); qty.dataset.kitItemQty=key; qty.setAttribute('aria-label',this.cfg.quantity_label+': '+item.title); qty.disabled=this.busy||this.locked;
        const price = document.createElement('span'); price.textContent=this.money.format(item.price*item.quantity/100);
        const remove = document.createElement('button'); remove.type='button'; remove.dataset.kitRemove=key; remove.textContent=this.cfg.remove_label; remove.setAttribute('aria-label',this.cfg.remove_label+': '+item.title); remove.disabled=this.busy||this.locked;
        const controls=document.createElement('div');controls.className='sk-stepper';
        for(const delta of [-1,1]){const step=document.createElement('button');step.type='button';step.dataset.kitStep=String(delta);step.dataset.kitKey=key;step.textContent=delta<0?'−':'+';step.setAttribute('aria-label',(delta<0?(this.cfg.decrease_label||'Diminuir quantidade'):(this.cfg.increase_label||'Aumentar quantidade'))+': '+item.title);step.disabled=this.busy||this.locked||(delta<0?item.quantity<=1:item.quantity>=99);controls.append(step);if(delta<0)controls.append(qty);}
        const row=document.createElement('div');row.className='sk-item-price-quantity';row.append(price,controls);
        li.append(text,row,remove);list.append(li);
      }
      this.querySelector('[data-kit-empty]').hidden = this.items.size > 0;
      this.querySelector('[data-kit-total]').textContent = this.money.format(total/100);
      this.querySelector('[data-kit-count]').textContent = String(units);
      this.querySelector('[data-kit-count-details]').textContent = String(units);
      this.querySelector('[data-kit-lines]').textContent = String(this.items.size);
      const shipping=this.querySelector('[data-kit-shipping]');
      const goal=Math.round(Number(String(this.cfg.shipping_goal).replace(',','.'))*100);
      shipping.hidden=!this.cfg.show_shipping || this.dataset.currency!=='BRL' || !(goal>0);
      if (!shipping.hidden) {
        this.querySelector('[data-kit-progress]').value=Math.min(100,total/goal*100);
        this.querySelector('[data-kit-shipping-message]').textContent=total>=goal ? this.cfg.shipping_reached : this.cfg.shipping_missing.replace('{valor}',this.money.format((goal-total)/100));
      }
      this.button.disabled=this.busy||this.locked||!this.items.size;
      this.button.textContent=this.busy?this.cfg.checkout_loading:this.cfg.checkout_label;
      if(this.sticky){
        this.querySelector('[data-kit-sticky-count]').textContent=String(units);
        this.querySelector('[data-kit-sticky-total]').textContent=this.money.format(total/100);
        const action=this.querySelector('[data-kit-sticky-checkout]');action.disabled=this.button.disabled;action.textContent=this.button.textContent;
        action.hidden=this.locked&&!this.busy;
        this.querySelector('[data-kit-sticky-review]').hidden=!(this.locked&&!this.busy);
        this.updateSticky();
      }
      this.grid.querySelectorAll('[data-kit-product]').forEach(card=>this.updateCard(card));
    }
    openSummary() {
      const details=this.summary.querySelector('details');if(details)details.open=true;
      this.summary.classList.add('sk-summary-expanded');
      this.summary.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    }
    updateSticky() {
      if(!this.sticky)return;
      const toolbar=this.querySelector('.sk-toolbar').getBoundingClientRect();
      const mobile=window.matchMedia('(max-width: 989px)').matches;
      const visible=this.items.size>0 && (mobile||toolbar.bottom<0) && this.getBoundingClientRect().bottom>0;
      this.sticky.hidden=!visible;
      this.closest('.sk-section')?.classList.toggle('sk-has-sticky',visible);
    }
    navigate(url) { location.assign(url); }
    async checkout() {
      if (this.busy || this.locked || !this.items.size) return;
      this.busy=true; this.feedback.textContent=''; this.renderSummary();
      const items=Array.from(this.items.values(),item=>({id:item.id,quantity:item.quantity,properties:{'_sagrada_kit':this.kitId,'Kit':this.cfg.kit_order_label}}));
      let attempted=false;
      try {
        // One request for the whole selection. Shopify validates prices and stock.
        attempted=true;
        const add=await fetch(this.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result=await add.json();
        if (!add.ok || result.status) throw new Error(result.description || result.message || this.cfg.checkout_error);
        const cartResponse=await fetch(this.root+'cart.js',{headers:{Accept:'application/json'}});
        if(!cartResponse.ok)throw new Error(this.cfg.review_message);
        const cart=await cartResponse.json();
        const committed=new Map();
        for(const line of cart.items||[])if(line.properties?._sagrada_kit===this.kitId)committed.set(String(line.variant_id||line.id),(committed.get(String(line.variant_id||line.id))||0)+line.quantity);
        if(!items.every(item=>committed.get(String(item.id))===item.quantity))throw new Error(this.cfg.review_message);
        this.locked=true;
        if(this.cfg.checkout_mode==='yampi') {
          const response=await fetch('https://api.dooki.com.br/v2/public/shopify/cart',{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({shop:location.host,shopify_internal_domain:this.dataset.shopDomain,cart_payload:cart})});
          if(!response.ok)throw new Error(this.cfg.review_message);
          const quote=await response.json();
          if(!quote.active||!quote.checkout_direct_url)throw new Error(this.cfg.review_message);
          let destination=new URL(quote.checkout_direct_url);
          if(destination.protocol!=='https:')throw new Error(this.cfg.review_message);
          if(typeof window.ymp_getUrlWithUtms==='function')destination=new URL(window.ymp_getUrlWithUtms(destination.href));
          if(destination.protocol!=='https:')throw new Error(this.cfg.review_message);
          this.navigate(destination.href);
        } else this.navigate(this.root+'cart');
      } catch(error) {
        // A rejected/ambiguous add can have changed stock quantities in the cart.
        // Never retry it automatically or clear the customer's existing cart.
        if(attempted)this.locked=true;
        this.feedback.textContent=(error.message||this.cfg.checkout_error)+' '+this.cfg.review_message;
        this.querySelector('[data-kit-review]').hidden=false;
      } finally { this.busy=false; if(this.isConnected)this.renderSummary(); }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selecao-essencial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sagrada-hero-carousel')) {
  customElements.define('sagrada-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.root = this.querySelector('.se-hero');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      if (!this.root || this.slides.length < 2) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.index = 0; this.hover = false; this.focused = false; this.editorPaused = false; this.touch = null; this.suppressClickUntil = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.reduced.matches;
      this.pauseButton = this.querySelector('[data-pause]');
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.move(-1), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.move(1), options);
      this.dots.forEach(dot => dot.addEventListener('click', () => { this.show(Number(dot.dataset.dot), true); this.restart(); }, options));
      this.pauseButton?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.label(); this.restart(); }, options);
      this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hover = true; this.restart(); } }, options);
      this.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { this.hover = false; this.restart(); } }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.restart(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.restart(); }, options);
      this.addEventListener('touchstart', event => {
        this.touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        this.restart();
      }, { ...options, passive: true });
      this.addEventListener('touchend', event => {
        if (!this.touch) return;
        const point = event.changedTouches[0];
        if (point) {
          const dx = point.clientX - this.touch.x, dy = point.clientY - this.touch.y;
          if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this.suppressClickUntil = Date.now() + 500;
            this.show(this.index + (dx < 0 ? 1 : -1), true);
          }
        }
        this.touch = null; this.restart();
      }, { ...options, passive: true });
      this.addEventListener('touchcancel', () => { this.touch = null; this.restart(); }, { ...options, passive: true });
      this.addEventListener('click', event => {
        if (Date.now() < this.suppressClickUntil) { event.preventDefault(); event.stopPropagation(); }
      }, { ...options, capture: true });
      document.addEventListener('visibilitychange', () => this.restart(), options);
      this.reduced.addEventListener('change', () => { this.userPaused = this.reduced.matches; this.label(); this.restart(); }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (index >= 0) { this.editorPaused = true; this.show(index); this.restart(); }
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; this.restart(); }, options);
      this.show(0); this.label();
      this.paintFrame = requestAnimationFrame(() => {
        this.paintFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.root.setAttribute('data-transitions-ready', '');
        });
      });
      this.slides.forEach((slide, index) => slide.querySelector('img')?.addEventListener('load', () => {
        if (this.index === index) this.restart();
      }, options));
      this.restart();
    }
    disconnectedCallback() { cancelAnimationFrame(this.paintFrame); this.root?.removeAttribute('data-transitions-ready'); clearTimeout(this.timer); this.events?.abort(); this.events = null; }
    label() {
      if (!this.pauseButton) return;
      this.pauseButton.textContent = this.userPaused ? 'Reproduzir' : 'Pausar';
      this.pauseButton.setAttribute('aria-label', this.userPaused ? 'Iniciar troca automática' : 'Pausar troca automática');
    }
    show(next, manual = false) {
      this.index = ((next % this.slides.length) + this.slides.length) % this.slides.length;
      const activeImage = this.slides[this.index].querySelector('img');
      if (activeImage && (manual || this.index > 0)) activeImage.loading = 'eager';
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); slide.inert = !active;
      });
      this.dots.forEach((dot, index) => { dot.classList.toggle('is-active', index === this.index); dot.setAttribute('aria-current', String(index === this.index)); });
      const status = this.querySelector('[data-slide-status]');
      if (status && manual) status.textContent = `Banner ${this.index + 1} de ${this.slides.length}`;
    }
    move(direction) { this.show(this.index + direction, true); this.restart(); }
    restart() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.root.dataset.autoplay !== 'true' || this.userPaused || this.hover || this.focused || this.editorPaused || this.touch || document.hidden) return;
      const currentImage = this.slides[this.index].querySelector('img');
      if (currentImage && !currentImage.complete) return;
      const nextImage = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
      if (nextImage) {
        nextImage.fetchPriority = (this.index + 1) % this.slides.length === 0 ? 'high' : 'low';
        nextImage.loading = 'eager';
      }
      this.timer = setTimeout(() => {
        if (!nextImage || (nextImage.complete && nextImage.naturalWidth > 0)) this.show(this.index + 1);
        this.restart();
      }, Math.max(3000, Number(this.root.dataset.speed) || 6000));
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
